const COMMON_URL = `${process.env.REACT_APP_EDI_ORIGIN_URL}/sinotrans-registration`

const SinotransRegistrationApiUrls = {
  GET: `${COMMON_URL}/get`,
  POST: `${COMMON_URL}/create`,
  PUT: `${COMMON_URL}/update`,
  DELETE: `${COMMON_URL}/delete`,
  EXPORT: `${COMMON_URL}/download`
};

export default SinotransRegistrationApiUrls
